<template>
    <div>
        <md-menu md-size="small">
            <md-button
                class="md-icon-button"
                md-menu-trigger
                @click.stop="getCustomAreas()"
            >
                <md-tooltip md-direction="top">Click to show asset on map</md-tooltip
                >
                <md-icon>map</md-icon>
            </md-button>

            <md-menu-content>
                <md-menu-item
                    v-for="area in customAreas"
                    :key="area"
                    @click.stop="loadAssetToMap(asset, area)"
                >
                    <md-icon>map</md-icon>
                    <span>{{ area }}</span>
                </md-menu-item>
                <md-menu-item key="null" @click.stop="loadAssetToMap(asset, null)">
                    <md-icon>add</md-icon>
                    <span>Create new area</span>
                </md-menu-item>
            </md-menu-content>
        </md-menu>
        <md-snackbar
            :md-position="'center'"
            :md-active.sync="snackbarActive"
            :md-duration="10000"
            md-persistent
            >
            <span>{{ snackbarMessage }}</span>
        </md-snackbar>
    </div>
</template>

<script>
import { AreaService } from "@/services/area.service";
import { functions } from "@/firebaseFunctions.js";
export default {
    name: "LoadAssetButton",
    props: {
        asset: {
            type: Object,
            required: true
        },
        user: {
            type: Object
        }
    },
    data() {
        return {
            customAreas: [],
            snackbarActive: false,
            snackbarMessage: "",
            loadingAsset: false
        }
    },
    methods: {
        getCustomAreas() {
            this.customAreas = AreaService.getCustomAreas();
        },
        loadAssetToMap(asset, area) {
            console.info("asked to map" , asset)
            console.info("with user data", this.user)
            // table is feature collection
            if(asset.type === "TABLE") {
                this.loadingAsset = true;
                // show snackbar
                this.snackbarMessage = "Loading asset...";
                this.snackbarActive = true;
                let data = {
                    "org_id": this.user.orgId,
                    "user_id": this.user.uid,
                    "asset_id": asset.id,
                }
                // gets mapURL and bbox
                functions.getTable(data).then((response) => {
                    console.info("response", response)
                    let mapURL = response.data.mapURL
                    let bbox = response.data.bbox
                    AreaService.addUserUploadedShape(area, bbox, mapURL, asset.id)
                    // show snackbar
                    this.snackbarMessage = "Asset added to map"
                    this.snackbarActive = true;
                }).catch(e => {
                    console.error("error", e)
                    this.snackbarMessage = "Error loading asset to map, please try again later"
                    this.snackbarActive = true;
                }).finally(() => {
                    this.loadingAsset = false;
                });
            }
        },
    }

}
</script>